import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles } from '@material-ui/core';

import DateRangePicker from '../../../DateRangePicker';
import styles from './styles';

const START_DATE = 'startDate';
const END_DATE = 'endDate';

const CustomDatePicker = (props) => {
  const { autoFocusEndDate, initialStartDate, initialEndDate, onCustomDatesChange } = props;
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const [focusedInput, setFocusedInput] = useState(autoFocusEndDate ? END_DATE : START_DATE);
  const [startDate, setStartDate] = useState(initialStartDate.toDate());
  const [endDate, setEndDate] = useState(initialEndDate.toDate());

  const onStartDateChange = (startDateParam) => {
    setStartDate(startDateParam);
    onCustomDatesChange({
      startDate: moment(startDateParam),
      endDate: moment(endDate),
    });
  }

  const onEndDateChange = (endDateParam) => {
    setEndDate(endDateParam);
    onCustomDatesChange({
      startDate: moment(startDate),
      endDate: moment(endDateParam),
    });
  }

  const onFocusChange = (focusedInput) => {
    setFocusedInput(!focusedInput ? START_DATE : focusedInput);
  }

  return (
    <div className={classes.calendarContainer}>
      <DateRangePicker
        daySize={36}
        endDate={endDate}
        focusedInput={focusedInput}
        hideKeyboardShortcutsPanel
        isRangePicker={true}
        minimumNights={0}
        numberOfMonths={2}
        noBorder
        onEndDateChange={onEndDateChange}
        onFocusChange={onFocusChange}
        onStartDateChange={onStartDateChange}
        startDate={startDate}
      />
    </div>
  );
}

CustomDatePicker.propTypes = {
  classes: PropTypes.shape(),
  autoFocusEndDate: PropTypes.bool,
  initialStartDate: PropTypes.shape(),
  initialEndDate: PropTypes.shape(),
  onCustomDatesChange: PropTypes.func,
};

export default CustomDatePicker;